module.exports = __webpack_public_path__ + "img/tu01.e3655e8b.jpg";